import React , { useState , useEffect  } from "react";
import useAuth from '../../../hooks/useAuth';
import GearSpinner from '../../../components/GearSpinner/GearSpinner';
import TrainingService from '../../../services/TrainingService';

const VideosTab = ({ active }) => {
    const { user } = useAuth();
    const [showLoader, setShowLoader] = useState(1);
    const [data , setData] = useState([]);
    const trainingService = new TrainingService();

    useEffect(() => {
        trainingService.getTrainingVideos({ portal_user_id: user.id }).then((response) => {
            const dataResponse = response.data;

            if (dataResponse.status === 'success') {
                if (dataResponse.result.length > 0) {
                    setData(dataResponse.result);
                }
            }

        }).finally(() => {
            setShowLoader(0);
        });

    },[active]);
    
    if (!active) return null;

    const renderNoData = () => {
        return (
            <div class="text-center my-5 fade-in">
                <div class="p-5 rounded-3 shadow-sm bg-light border mx-5">
                    <h3 class="fw-bold text-dark">Data not found.</h3>
                    
                </div>
            </div>
        )
    }

    const renderVideos = () => {
        if (showLoader) {
            return <GearSpinner />;
        }

        return (
            <React.Fragment>
                {data.length > 0 ? (
                        data.map((value, index) => (
                            <React.Fragment>
                                <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">	
                                    <div className="card trainingBox border-0">
                                        <div
                                            style={{
                                                position: "relative",
                                                width: "100%",
                                                height: 0,
                                                paddingTop: "56.25%",
                                                overflow: "hidden"
                                            }}
                                            >
                                            <iframe
                                                src={value.file}
                                                style={{
                                                position: "absolute",
                                                width: "100%",
                                                height: "100%",
                                                top: 0,
                                                left: 0,
                                                border: "none"
                                                }}
                                                allowFullScreen
                                                loading="lazy"
                                            ></iframe>
                                        </div>
                                        <div className="card-footer text-center">
                                            <h6>{value.title}</h6>
                                        </div>
                                    </div>
                                </div>

                            </React.Fragment>
                        ))
                    ) : (
                        renderNoData()
                    )
                }
            </React.Fragment>
        )
    }
    
    return (
        <React.Fragment>
            <div className="row tab-scroll">
                <div className="col-md-12">
                    <h5>Videos</h5>
                    <div className="row mt-5">														
                        <div className="col-md-12">
                            <div className="row g-3">
                                {renderVideos()}
                            </div>
                        </div>
                    </div>
                </div>		
            </div>	
        </React.Fragment>
    );
};

export default VideosTab;